import axios from 'axios';

type WorkatoData = {
  /** The original data object or string */
  data: string | object;
  errors: {
    /** The error message */
    message: string;
    /** The error code */
    code?: string;
    /** The error status */
    status?: string | null;
  };
};

const workato = async (data: WorkatoData) => {
  const formattedData = JSON.stringify(data);

  try {
    const response = await axios({
      method: 'POST',
      url: 'https://webhooks.workato.com/webhooks/rest/b2fe5293-b9e8-4bb4-81ec-7d678a823a0b/webformerror',
      data: formattedData,
    });

    if (response.status === 200) {
      return {
        message: 'Submitted to fallback endpoint.',
      };
    }

    return;
  } catch (error) {
    console.error(`Workato Error: ${error}`);
    throw new Error(error);
  }
};

export default workato;
